export default __webpack_public_path__ + "static/media/cpv_32_telecom.74dcf75a.svg";